import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../styled-components/components/Modal';
import VideoPlayer from '../video-player/video-player-selector';

const KEY_CODE_ESC = 27;

const ToggleClassName = 'reset-webkit-overflow-scrolling';

interface ModalVideoPlayerProps {
  url: string;
  onClose: () => void;
}

const ModalVideoPlayer = ({ url, onClose }: ModalVideoPlayerProps) => {
  const { t } = useTranslation('article');

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.keyCode === KEY_CODE_ESC) onClose();
    };

    window.focus();
    window.addEventListener('keydown', onKeyDown);
    if (document && document.body) document.body.className += ` ${ToggleClassName}`;
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      if (document && document.body)
        document.body.className = document.body.className
          ? document.body.className.replace(ToggleClassName, '').trim()
          : '';
    };
  }, []);

  return (
    <Modal heading={t('playVideo', { ns: 'item' })} onClose={onClose}>
      <VideoPlayer url={url} autoplay={true} />
    </Modal>
  );
};

export default ModalVideoPlayer;
